import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { generateGames12LogBased, getGameByEventId } from '../../features/game/gameSlice';

//Games will be generated based on the initial draw or the log, the round, and assign a green.

const GenerateSectionGames = ({ event, section }) => {
  const [open, setOpen] = useState(false);
  const [round, setRound] = useState(1);
  const dispatch = useDispatch();

  const hasRounds = event.gameFormat.rounds > 1;
  const hasLog =
    (section.baseLog && section.baseLog.length > 0) ||
    (section.initialDraw && section.initialDraw.length > 0);
  const hasGreenSetups = event.greens && event.greens.length > 0;
  const canGenerate = hasRounds && hasLog && hasGreenSetups;

  const onClose = () => {
    setOpen(false);
    setRound(1);
  };

  const onSubmit = () => {
    dispatch(
      generateGames12LogBased({
        event,
        section,
        round
      })
    )
      .unwrap()
      .then(() => {
        onClose();
        dispatch(getGameByEventId(event.id));
      })
      .catch((error) => {
        console.error('Error generating games:', error);
      });
  };

  return (
    canGenerate && (
      <>
        <Button variant="outlined" color="primary" onClick={() => setOpen(true)}>
          Generate Games
        </Button>

        <Dialog open={open} onClose={onClose}>
          <DialogTitle>Generate Games</DialogTitle>
          <DialogContent>
            <Box display={'flex'} flexDirection={'column'} gap={2}>
              <Box>
                <p>
                  Games will be generated based on the initial draw or the log, the round, and
                  assign a green.
                </p>
              </Box>
              <Box>
                <p>Click on the button below to generate games for this section.</p>
              </Box>

              {/* Select Round */}
              {event.gameFormat.rounds > 0 && (
                <Select
                  name="round"
                  label={'Round'}
                  value={round}
                  onChange={(e) => setRound(e.target.value)}>
                  {(() => {
                    let container = [];
                    for (let i = 0; i < event.gameFormat.rounds; i++) {
                      container.push(
                        <MenuItem key={i} value={i + 1}>
                          Round {i + 1}
                        </MenuItem>
                      );
                    }
                    return container;
                  })()}
                </Select>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" color="primary" onClick={() => onSubmit()}>
              Generate Games
            </Button>
            <Button variant="outlined" color="secondary" onClick={onClose}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )
  );
};

export default GenerateSectionGames;
